import React from 'react';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';
import { BRAND_THEME } from '../../ui/brandTheme';

/**
 * DateSlotNavigator - 15-day slot navigation component
 * Shows current 15-day slot with prev/next navigation
 * Shared by Dashboard Activity + Payroll time-card modal.
 */
const DateSlotNavigator = ({ currentSlot, onSlotChange, loading = false, compact = false }) => {
    const formatDateDisplay = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const year = String(d.getFullYear()).slice(-2);
        return `${month}/${day}/${year}`;
    };

    return (
        <div
            className={`flex items-center gap-2 bg-white border rounded-md ${compact ? 'px-2.5 py-1.5' : 'px-3 py-1.5'} ${BRAND_THEME.section.wrap}`}
        >
            <span className="font-medium whitespace-nowrap text-slate-600 text-[13px]">
                Pay period
            </span>

            <button
                onClick={() => onSlotChange('prev')}
                disabled={loading}
                className={`p-1 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.menuHover}`}
                aria-label="Previous 15 days"
            >
                <ChevronLeft className="w-4 h-4 text-indigo-600" />
            </button>

            <div
                className={`flex items-center gap-1.5 rounded border justify-center bg-indigo-50/60 border-indigo-100 ${compact ? 'px-2.5 py-1 min-w-[168px]' : 'px-2.5 py-1 min-w-[180px]'}`}
            >
                <Calendar className="w-4 h-4 text-indigo-500 shrink-0" />
                <span className="font-medium text-slate-700 tabular-nums text-[13px]">
                    {currentSlot.start ? formatDateDisplay(currentSlot.start) : ''} -{' '}
                    {currentSlot.end ? formatDateDisplay(currentSlot.end) : ''}
                </span>
            </div>

            <button
                onClick={() => onSlotChange('next')}
                disabled={loading}
                className={`p-1 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.menuHover}`}
                aria-label="Next 15 days"
            >
                <ChevronRight className="w-4 h-4 text-indigo-600" />
            </button>
        </div>
    );
};

export default DateSlotNavigator;
